import { useMemo, useState } from 'react';
import { ISSUES_COMPONENT_CATALOG, DEFAULT_VERSION } from '../config/versions';
import { SharedComponentVersion } from '../types';

export function useComponentVersionSelection() {
  const [selectedVersion, setSelectedVersion] =
    useState<SharedComponentVersion>(DEFAULT_VERSION);

  const currentVersionOption = useMemo(
    () =>
      ISSUES_COMPONENT_CATALOG.find((v) => v.value === selectedVersion) ||
      ISSUES_COMPONENT_CATALOG[0],
    [selectedVersion],
  );

  return {
    selectedVersion,
    setSelectedVersion,
    currentVersionOption,
    availableVersions: ISSUES_COMPONENT_CATALOG,
  };
}
